import styled, { css } from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

export const _LandingHighlighProductMargauxMotinRoot = styled("section")<{}>(
  () => {
    return css`
      position: relative;
      padding: 16px;
      padding-top: 100px;

      @media ${responsiveMap.mobile} {
        padding: 24px;
        padding-top: 0;
      }

      .landing-action-button {
        @media ${responsiveMap.maxLg} {
          width: 100%;
        }
      }

      .top-container {
        @media ${responsiveMap.maxLg} {
          margin-bottom: 32px;
        }
      }

      .landing-section-base__head__content {
        position: relative;
        padding-bottom: 100px;
        @media ${responsiveMap.mobile} {
          padding-bottom: 0;
        }
        .price-list-container {
          position: absolute;
          right: 0;
          bottom: 0;
          transform: translate(58%, 0);

          @media ${responsiveMap.mobile} {
            position: static;
            transform: none;
            margin-bottom: -24px;
          }
        }
      }

      .composition-container {
        @media ${responsiveMap.mobile} {
          margin-bottom: -0;
        }
      }

      .landing-section-base__head__top__container {
        @media ${responsiveMap.mobile} {
          text-align: left !important;
        }
      }

      .landing-section-base__head__middle {
        align-items: baseline;
        /* max-width: 711px; */
        max-width: 67%;
        position: relative;

        @media ${responsiveMap.mobile} {
          max-width: 466px;
          margin: 0 auto;
        }

        .decorations-1 {
          position: absolute;
          top: 0;
          left: 0;
          transform: translate(45%, -50%);
          max-width: 15%;
          max-width: unset;

          @media ${responsiveMap.mobile} {
            transform: translate(0%, -49%);
            .decoration-box-img {
              max-width: 64px;
            }
          }
        }

        .decorations-2 {
          position: absolute;
          top: 0;
          right: 0;
          transform: translate(0%, 30%);
          max-width: 13%;

          @media ${responsiveMap.mobile} {
            top: unset;
            right: 0px;
            bottom: 0px;
            transform: translate(0%, 20%);
            max-width: unset;

            .decoration-box-img {
              max-width: 57px;
            }
          }
        }

        .decorations-3 {
          position: absolute;
          bottom: 0;
          right: 0;
          transform: translate(98%, 12%);
          max-width: 32%;

          @media ${responsiveMap.mobile} {
            right: 0px;
            bottom: 0px;
            transform: translate(0%, 193%);
            max-width: unset;

            .decoration-box-img {
              max-width: 117px;
            }
          }
        }
      }

      .composition-items {
        .composition-item-separator {
          margin-bottom: 10px;
        }
      }

      .landing-section-base-margaux-motin {
        .landing-section-base__head__container {
          padding: 0px;
          grid-template-columns: 33% 67%;
          column-gap: 70px;
        }
      }

      .landing-action-button {
        @media ${responsiveMap.mobile} {
          width: unset;
        }
      }
    `;
  }
);
